import { Component, inject, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-confirm-modal',
    standalone: true,
    imports: [TranslocoModule, NgIf],
    templateUrl: './confirm-modal.component.html',
    styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent {

    @Input() message?: string;
    @Input() title?: string;
    @Input() showCancel: boolean = true;

    protected readonly activeModal = inject(NgbActiveModal);

}
